
<app-header></app-header>

<div id="page-container">
    <router-outlet></router-outlet>
</div>

<app-footer></app-footer>